export default {
    OUTSTANDING_SHARES_DATE: 'outstandingSharesDate',
    TRANSACTIONS_DATE_RANGE: 'transactionsDateRange'
};
